import React from 'react';

// Components
import * as S from './Styled';

const Radio = props => {
  return (
    <S.Label htmlFor={props.id}>
      <S.Input type="radio" id={props.id} {...props} />
      <S.Value />
    </S.Label>
  );
};

export default Radio;
